import Environment from "../utils/Environment";
import axios from "axios";
import { API_URL } from "../utils/ApiUrl";

export const initEnvironment = async (projectTicker) => {
  if (!projectTicker) {
    throw new Error("Project ticker missing from URL");
  }

  const response = await axios.get(
    `${API_URL}pro-projects/${projectTicker}/purchase-info`,
  );

  if (!response?.data?.data.length) {
    throw new Error("Project data not found");
  }

  const data = response?.data?.data?.[0];

  Environment.presale = {
    name: data?.projectName,
    detailPage: `presale/${data?._id}`,
    symbol: data?.projectTicker,
    apiTag: data?.projectTicker,
    apiUrl: `users/buy-${data?.projectTicker?.toLowerCase()}`,
    image: data?.projectImage,
    contractVersion: data?.contractVersion,
    nftDetails: data?.nftDetails,
  };
  Environment.presaleContract = data.preSaleContract;
  //   Environment.privateSaleGraph = data.privateSaleGraph;

  return data;
};
